import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['ProductAddon', 'BookingInfo', 'customProperties'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAddOns: builder.query({
        query: ({ fisheryId, packageId, lakeId }) => ({
          url: `booking/fishery/products`,
          params: {
            fishery_id: fisheryId,
            package_id: packageId,
            lake_id: lakeId,
          },
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'ProductAddon' }],
      }),
      getCustomProperties: builder.query({
        query: ({ fisheryId, bookingType, lakeId, online = false }) => ({
          url: `fishery/booking/custom_properties`,
          params: {
            fishery_id: fisheryId,
            booking_type: bookingType,
            lake_id: lakeId,
            online_booking: online,
          },
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'customProperties' }],
      }),
      getBookingInfo: builder.query({
        query: (id) => ({
          url: `fishery/booking/info?id=${id}`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'BookingInfo' }],
      }),
      resendBookingConfirmation: builder.mutation({
        query: (id) => ({
          url: `fishery/booking/resend_confirmation?booking_id=${id}`,
          method: 'POST',
          data: {},
        }),
      }),
      initiateRefund: builder.mutation({
        query: (data) => ({
          url: `fishery/initiate_refund`,
          method: 'POST',
          data: data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'BookingInfo' },
          { type: 'RefundValue' },
        ],
      }),
      updateTaxiInformation: builder.mutation({
        query: (data) => ({
          url: `fishery/booking/taxi_information`,
          method: 'PUT',
          data: data,
        }),
      }),
      editCustomProperties: builder.mutation({
        query: (data) => ({
          url: `fishery/booking/custom_properties`,
          method: 'PUT',
          data: data,
        }),
      }),
      checkPassword: builder.mutation({
        query: (data) => ({
          url: `fishery/check_password`,
          method: 'POST',
          data: data,
        }),
      }),
      resendBalanceReminder: builder.mutation({
        query: (id) => ({
          url: `fishery/booking/send_reminder?booking_id=${id}`,
          method: 'POST',
          data: {},
        }),
      }),
      resendReservationBalanceReminder: builder.mutation({
        query: (id) => ({
          url: `fishery/fishery-reservations/resend_payment_link?package_booking_id=${id}`,
          method: 'get',
          data: {},
        }),
      }),
    }),
  });

export const {
  useGetAddOnsQuery,
  useGetBookingInfoQuery,
  useResendBookingConfirmationMutation,
  useResendBalanceReminderMutation,
  useGetCustomPropertiesQuery,
  useEditCustomPropertiesMutation,
  useUpdateTaxiInformationMutation,
  useInitiateRefundMutation,
  useCheckPasswordMutation,
  useResendReservationBalanceReminderMutation,
} = extendedApiSlice;
